module.exports = __webpack_public_path__ + "static/media/da-vinci-ice.680b745b.webp";